type Locale = 'en' | 'es';
interface Vars {
  days: string;
}
type Phrase = (l: Locale, v: Vars) => string;

// eslint-disable-next-line camelcase
export const i18n_try_free_for_x_days: Phrase = (locale, { days }) => {
  const phrases: { [key: string]: undefined | string } = {
    en: `Try free for ${days} days`,
    es: `${days} días de prueba gratis.`,
  };
  return phrases[locale] || phrases.en || 'try_free_for_x_days';
};
